"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SsoSDK = void 0;
const axios_1 = __importDefault(require("axios"));
class SsoSDK {
    constructor(params) {
        const { env, url } = params;
        this.setSsoUrl(env, url);
        if (env === 'dev' && !url) {
            throw new Error('Url is mandatory with development environment');
        }
        this.api = axios_1.default.create({
            baseURL: this.getSsoUrl()
        });
    }
    async tokenIsValid(token) {
        try {
            const { status } = await this.api.get('/auth/check', {
                headers: {
                    authorization: `Bearer ${token}`
                }
            });
            return status === 204;
        }
        catch (error) {
            return false;
        }
    }
    async logout(token) {
        await this.api.get('/auth/logout', {
            headers: {
                authorization: `Bearer ${token}`
            }
        });
    }
    setSsoUrl(env, ssoUrl) {
        const envs = new Map()
            .set('hmg', 'https://ssohmg.rockcontent.com')
            .set('prd', 'https://sso.rockcontent.com')
            .set('dev', ssoUrl);
        this.ssoUrl = envs.get(env);
    }
    getSsoUrl() {
        return this.ssoUrl;
    }
}
exports.SsoSDK = SsoSDK;
//# sourceMappingURL=sso.js.map